/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';

import template from './advertiser-earnings-widget.component.html';
import {StatsResource} from '../../../components/api/resources/resource/stats-resources/stats-resource';
import {ChartOptionsUtil} from '../../common/options/chart-options-util.service';
import {deferMarkForCheck} from '../../common/util/defer-mark-for-check';

@Component({
  standalone: false,
  selector: 'adn-advertiser-earnings-widget',
  template
})
export class AdvertiserEarningsWidgetComponent implements OnInit {
  @Input() widgetType: any;

  obj: any;
  tableFields: any[] = [];
  fieldComparisons: any[] = [];
  readonly childParam = 'earningsAccount';
  rows: any[] = [];
  totals: any;
  isDone = false;
  hasError = false;

  constructor(
    private readonly statsResource: StatsResource,
    @Inject(ChartOptionsUtil) private readonly ChartOptionsUtil: any,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    if (!_.get(this.widgetType, ['obj', 'id'])) {
      return;
    }

    const chartOptions = this.ChartOptionsUtil.getOptions('ADVERTISER');
    this.tableFields = _.filter(chartOptions.totalsFields, (field: any) => {
      return this.widgetType.fields.indexOf(field.id) > -1;
    });
    this.obj = this.widgetType.obj;
    this.fieldComparisons = this.widgetType.fieldComparisons;

    const params: any = {
      aggregateTo: 'ADVERTISER',
      groupBy: 'EARNINGS_ACCOUNT',
      includeAll: false,
      advertiserId: this.obj.id,
      includeChunkRange: true,
      startDate: this.widgetType.startDate,
      endDate: this.widgetType.endDate
    };
    if (_.isArray(this.widgetType.objMulti) && this.widgetType.objMulti.length > 0) {
      params.earningsAccountId = _.join(_.map(this.widgetType.objMulti, (om: any) => om.id), ';');
    }

    this.isDone = false;
    this.hasError = false;
    this.statsResource.get(params, (data: any) => {
      deferMarkForCheck(this.cdr, () => {
        this.rows = data.chunks;
        this.totals = data.totals;
        this.isDone = true;
      });
    }, () => {
      deferMarkForCheck(this.cdr, () => {
        this.hasError = true;
        this.isDone = true;
      });
    }, this);
  }

  childData(row: any): any {
    return row?.[this.childParam];
  }

  showFieldLabel(field: any): boolean {
    return !field.abbr || field.extra;
  }

  comparisonRatio(value: any, target: number): number {
    const amount = value?.amount ?? value;
    return amount / target;
  }

  get showNoDataWarning(): boolean {
    return !(this.rows?.length && this.rows[0]?.chunks);
  }

  get showTable(): boolean {
    return !!(this.rows?.length && this.rows[0]?.chunks);
  }
}
